import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import * as authenticationTypes from '../../types';

@Component({
  selector: 'tr-reset-password',
  templateUrl: './reset-password.component.html',
  //styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  @Output() authenticate = new EventEmitter<authenticationTypes.ICredentials>();
  @Input() isBusy: boolean;
  @Input() message: string;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    let username: string = '';

    this.forgotPasswordForm = this.fb.group({
      'username': [ username, Validators.compose([ Validators.required, CustomValidators.email ]) ]
    });
  }

  onSubmit(): void {
    this.authenticate.emit(this.forgotPasswordForm.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/reset-password/reset-password.component.ts